import { relativeAgo, isStale } from './freshness.js';
import type { SyncSource } from '../api.js';

const STALE_HOURS = 12;

/** Ribbon copy for Today, or null when the phone pipeline looks healthy. */
export function ribbonMessage(sources: SyncSource[], now: Date = new Date()): string | null {
  const apple = sources.find((s) => s.source === 'apple_health');
  if (!apple) return null;
  const at = apple.lastReceivedAt ?? apple.lastSyncAt;
  if (!at) return 'No phone sync recorded yet — open Vitals on your iPhone to sync.';
  if (!isStale(at, STALE_HOURS, now)) return null;
  return `Phone last synced ${relativeAgo(at, now)} — open Vitals on your iPhone to sync.`;
}
